import React from 'react';

import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {type RouteData} from '../types';
import {MARIMO_NOTEBOOK_EDIT_PATH, NOTEBOOKS_PATH} from './notebookPaths';

export const NOTEBOOKS_HOME_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // HomePageWithData handles tracking via HOME_NESTED_ROUTES
    },
    exact: true,
    isPrivateRoute: true,
    path: NOTEBOOKS_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/HomePage/HomePageWithData')
    ).Component,
  },
];

export const NOTEBOOK_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true,
    },
    exact: true,
    isPrivateRoute: true,
    path: MARIMO_NOTEBOOK_EDIT_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/MarimoNotebookRuntimePage')
    ),
  },
];
